import { WITH_RULE_ENGINE } from "@src/config/constant";
import {
  addCurrencyFormatting,
  removeCurrencyFormattingId,
  isValidDecimal,
  roundPercent,
} from "@src/config/helper";

import { toast } from "react-toastify";

export const handleCheckboxChange = (
  requestData?: any,
  setAddonState?: any,
  addon?: any,
  checked?: boolean,
  setError?: any
) => {
  const isRuleEngine = requestData?.rule_engine === WITH_RULE_ENGINE;

  let premium = 0;
  let coverage:any ={}
  let passengers:any ={}
  const item  = structuredClone(addon) ;
  if(addon?.default_sum_insured){
    coverage = item?.coverage_list?.find((row: any) => row.value === item?.default_sum_insured) || coverage
    coverage.label = addCurrencyFormatting(coverage.label)
    premium = isRuleEngine ? coverage?.premium_amount:premium
  }
  if(addon?.default_passenger){
    passengers ={
      label: addon?.default_passenger,
      value: addon?.default_passenger
    }
    premium = isRuleEngine ? coverage?.premium_amount * addon?.default_passenger :premium
  }
  if (addon?.rate && isRuleEngine) {
    premium =addon?.premium_amount
  }
  
  if(!checked) premium = 0
  
  setAddonState((prev: any) => ({
    ...prev,
    [addon.id]: {
      checked,
      premium: premium,
      coverage,
      passengers
    },
  }));

  if(setError){

    setError((prev: any) => {
      const copy = { ...prev };
      delete copy[`premium_${addon.id}`];
      return copy;
    });
  }
};

export const handleCoverageChange = (
  addon: any,
  selected: any,
  setAddonState: any,
  isRuleEngine: boolean,
) => {
  const premium_amount = isRuleEngine
    ? addon?.coverage_list?.find((row: any) => row.value === selected?.value)
        ?.premium_amount || 0
    : 0;
  setAddonState((prev: any) => ({
    ...prev,
    [addon.id]: {
      checked: true,
      coverage: selected,
      premium: premium_amount,
    },
  }));
};

export const handleManualPremiumChange = (
  item: any,
  value: any,
  setAddonState: any,
  setError?: any,
) => {
  setAddonState((prev: any) => ({
    ...prev,
    [item.id]: {
      ...prev[item.id],
      checked: true,
      premium: value,
    },
  }));

  if(setError){

    setError((prev: any) => {
      const copy = { ...prev };
      if(copy[`premium_${item.id}`]){
        delete copy[`premium_${item.id}`];
      }
      return copy;
    });
  }

};
export const handlePassengerChange = (
  addon: any,
  selected: any,
  setAddonState: any,
  requestData:any,
  addonState?: any
) => {

  const isRuleEngine = requestData?.rule_engine === WITH_RULE_ENGINE;
  let premium = 0;
  const state = addonState[addon.id];
  if(state?.coverage?.value && isRuleEngine){
    premium = state?.coverage?.premium_amount * selected?.value || 0
  }

  setAddonState((prev: any) => ({
    ...prev,
    [addon.id]: {
      ...prev[addon.id],
      passengers: selected,
      premium
    },
  }));
};

export const totalAddonCostBtRange = (addonState: any, isRuleEngine?: boolean, tenure?: number) => {
  
  if(!isRuleEngine){
   return totalAddonCost(addonState);
  }
  
  let minTotal = 0;
  let maxTotal = 0;

  Object.values(addonState).forEach((addon: any) => {
    if (!addon?.premium) return;

    const premiumStr = addon?.premium?.toString() || '';

    // 🔹 Case 1: Range hai ("Rp 15.000 - Rp 20.000")
    if (premiumStr?.includes('-')) {
      const [minStr, maxStr] = premiumStr.split('-').map((s: any) => s.trim());

      const min = Number(removeCurrencyFormattingId(minStr));
      const max = Number(removeCurrencyFormattingId(maxStr));

      minTotal += min;
      maxTotal += max;
    } 
    // 🔹 Case 2: Single value ("Rp 10.000")
    else {
      const value = Number(removeCurrencyFormattingId(premiumStr));

      minTotal += value;
      maxTotal += value;
    }
  });

  if (Number(tenure) === 1) {
    return addCurrencyFormatting(minTotal);
  }

  return `${addCurrencyFormatting(minTotal)} - ${addCurrencyFormatting(maxTotal)}`;
};

export const totalAddonCost = (addonState: any) => {
  const total = Object.values(addonState).reduce((sum: number, addon: any) => {
    const premium = addon?.premium
      ? Number(removeCurrencyFormattingId(addon.premium))
      : 0;

    return sum + premium;
  }, 0);

  return addCurrencyFormatting(total);
};
export const validateAddons = async (
  requestData: any,
  addonState: any,
  setError: any,
  translations?: any
) => {
  const isRuleEngine = requestData?.rule_engine === WITH_RULE_ENGINE;

  let isValid = true;
  const errors: any = {};
  
  const hasAnyAddonSelected = Object.values(addonState).some(
    (addon: any) => addon?.checked==true
  );

  if (!hasAnyAddonSelected) {
    setError({});
    errors['addons'] = 'Please select some add-ons';
    toast.error(translations?.CREATE_APP?.ONE_ADDON_REQUIRED);
    isValid = false;
  }

  // Validation only for WITHOUT rule engine
  if (!isRuleEngine && !errors['addons'] && hasAnyAddonSelected) {
    Object.keys(addonState).forEach((id: any) => {
      const state = addonState[id];
      const premiumValue = Number(removeCurrencyFormattingId(state?.premium));

      const isAddonActive = state?.checked

      if (isAddonActive && (!premiumValue || premiumValue <= 0)) {
        isValid = false;
        errors[`premium_${id}`] = translations?.CREATE_APP?.PREMIUM_AMT_REQUIRED
      }
    });
  }

  setError(errors);

  return {
    isValid,
    errors,
  };
};

export const updateAddons = async (
  requestData: any,
  addonState: any,
  setError: any,
  translations?:any
) => {
  const validate:any = await validateAddons(requestData, addonState, setError,translations);
  if(!validate?.isValid) return validate

  const addon_detail: any[] = [];

  Object.keys(addonState).forEach((id) => {
    const state = addonState[id];
    if (state.checked) {
      const addon: any = {
        id: Number(id),
        premium_amount: state.premium,
      };

      if (state.coverage?.value) {
        addon.coverage_amount = state.coverage.value;
      }
      if (state.passengers?.value) {
        addon.seat_capacity = state.passengers.value;
      }

      addon_detail.push(addon);
    }
  });
  return addon_detail;
};

/**
 * Lead detail returns one addon row per tenure year (lead_addons has a row per lead_tenure_id),
 * so a 2-year lead with 2 addons comes back with 4 entries. The request/quote needs each addon once.
 */
export const uniqueAddonDetail = (addons: any[] = []) => {
  if (!Array.isArray(addons)) return [];
  const seen = new Set<string>();
  return addons.filter((addon: any) => {
    if (addon?.id === undefined || addon?.id === null) return false;
    const key = String(addon.id);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/**
 * Saved customer discount of a lead for the Quote inputs (Edit / Continue Application).
 * discount_type 1 = % discount -> customer_discount_per, 2 = amount -> customer_discount.
 * Falls back to whichever value is set (older leads have no discount_type).
 */
export const getSavedDiscount = (data: any): { type: number; value: number } | null => {
  const percent = Number(data?.customer_discount_per) || 0;
  const amount = Number(data?.customer_discount) || 0;
  const type = Number(data?.discount_type) || 0;
  // The API stores both columns: an amount entry also saves its derived % (up to 6 dp) and a
  // % entry also saves its derived amount. A % with more than 4 decimals can't have been typed,
  // so when the type wasn't saved it means the agent entered an amount.
  const percentFromAmount = percent > 0 && !isValidDecimal(percent);
  if (type === 1 && percent > 0) return { type: 1, value: roundPercent(percent) };
  if (type === 2 && amount > 0) return { type: 2, value: amount };
  if (amount > 0 && (percentFromAmount || percent <= 0)) return { type: 2, value: amount };
  if (percent > 0) return { type: 1, value: roundPercent(percent) };
  return null;
};
